<app-section-title [title]="contentService.content().mainPage.myReferences.title" (click)="triggerScroll('references')"></app-section-title>


<div id="mobileText">
    <p id="mobileTitle">{{ contentService.content().mainPage.myReferences.mobileText.title }}</p>
    <p id="mobileSubtitle">{{ contentService.content().mainPage.myReferences.mobileText.subtitle }}</p>
</div>


<div id="all-references" #scrollContainer (scroll)="onScroll(scrollContainer)">
    @for (reference of contentService.content().mainPage.myReferences.references; track reference.author; let i = $index) {
    <div class="reference-container">
        <div class="reference-text">{{ reference.text }}</div>
        <div class="about-reference">
            <p>{{ reference.author }}</p>
            <p>{{ reference.context }}</p>
        </div>
    </div>
    }
</div>


<div class="scroll-marker-group">
    @for (reference of contentService.content().mainPage.myReferences.references; track reference.author; let i = $index) {
    <button
        class="scroll-marker" 
        [class.active]="activeStep() === i"
        (click)="scrollToIndex(scrollContainer, i)"
        [attr.aria-label]="'Gehe zu Referenz ' + (i + 1)">
    </button>
    }
</div>